import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NavigationConfig } from '../navigation/navigation-config';
import {
  InventoryLink,
  NavigationDropdown,
  NavigationItem,
} from '../navigation/navigation-item';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  items: NavigationItem[];
  inventoryItems: InventoryLink[];
  supportItems: NavigationItem[];
  upgradePlanItem: NavigationItem;
  
  private openChangeSubject = new Subject<NavigationDropdown>();
  openChange$ = this.openChangeSubject.asObservable();

  triggerOpenChange(item: NavigationDropdown) {
    this.openChangeSubject.next(item);
  }

  initializeNavigation(navigationConfig: NavigationConfig) {
    this.items = navigationConfig.items;
    this.inventoryItems = navigationConfig.inventoryItems;
    this.supportItems = navigationConfig.supportItems;
    this.upgradePlanItem = navigationConfig.upgradePlanItem;
  }
}
